import { BaseRepository } from "repositories/BaseRepository";

export class AgentLinesRepository extends BaseRepository {
  constructor(db) {
    super(db, "agentLines");
  }
}
